// extracted by mini-css-extract-plugin
export default {"contextPropertyValue":"TraceLogDetailPanel_contextPropertyValue__k4CwX","contextPropertiesRaw":"TraceLogDetailPanel_contextPropertiesRaw__r804b"};